// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3748":"css/admin-app.7017","8689":"css/app.7017"}[chunkId] + ".css";
};